import { SmallTitle, SubsectionTitle } from '@sleepstation/components'
import { Select } from '@sleepstation/components-form'
import { BreakingLayout, VLayout } from '@sleepstation/components-layouts'
import { DIRECTION, LAYOUT_ALIGN, LAYOUT_SPACING } from '@sleepstation/const'
import { minWidth } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import ResourcesList from '../ResourcesList'
import useFilter from './useFilter'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.LARGE,
})``

const Header = styled(BreakingLayout).attrs({
  direction: [DIRECTION.VERTICAL, DIRECTION.HORIZONTAL],
  spacing: [LAYOUT_SPACING.MEDIUM, LAYOUT_SPACING.BETWEEN],
  align: [LAYOUT_ALIGN.LEFT, LAYOUT_ALIGN.CENTER],
})``

const Body = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
})``

const SelectWrapper = styled.div`
  align-self: stretch;

  > * {
    ${minWidth(7)}
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const ResourcesGroup = ({ title, resources, isFiltered, dataCy }) => {
  const {
    setSelectedCategory,
    resolvedResources,
    availableOptions,
    selectedCategory,
  } = useFilter(resources, isFiltered)

  return (
    <Layout data-cy={dataCy}>
      <Header>
        <SubsectionTitle>{title}</SubsectionTitle>
        {isFiltered && (
          <SelectWrapper aria-label="Select a session">
            <Select
              name={`Session select`}
              options={availableOptions}
              value={selectedCategory}
              dataCy="session-select"
              onChange={({ target: { value } }) => {
                setSelectedCategory(value)
              }}
            />
          </SelectWrapper>
        )}
      </Header>
      <Body>
        {isFiltered && (
          <SmallTitle data-cy="resource-group-title">
            {selectedCategory}
          </SmallTitle>
        )}
        <ResourcesList resources={resolvedResources} />
      </Body>
    </Layout>
  )
}

ResourcesGroup.propTypes = {
  title: PropTypes.string.isRequired,
  isFiltered: PropTypes.bool,
  dataCy: PropTypes.string.isRequired,
  resources: PropTypes.arrayOf(PropTypes.object),
}

ResourcesGroup.defaultProps = {
  resources: [],
  isFiltered: false,
}

export default ResourcesGroup
